import React, { ReactNode } from 'react';
import { Stack, Title } from '@mantine/core';
import ModalPopupComponent from 'components/ModalPopup';

interface FilterModalProps {
  opened: boolean;
  onClose: () => void;
  children: ReactNode;
  title?: string;
  size?: 'md' | 'xs' | 'sm' | 'lg' | 'xl' | 'full';
}

const FilterModal: React.FC<FilterModalProps> = ({
  opened,
  onClose,
  children,
  title = 'Filter',
  size = 'md'
}) => {
  return (
    <ModalPopupComponent opened={opened} close={onClose} size={size}>
      <Stack p='lg' gap='md'>
        <Title order={3}>{title}</Title>
        {children}
      </Stack>
    </ModalPopupComponent>
  );
};

export default FilterModal;
